import { IDirectDealFilter, IDirectDealFilterOption } from '../../constants/filter/directDealFilter.constant';
import { priceSliderValueMapping } from '../../constants/filter/slider/filterSliderConstant';

interface ICreateDirectDealFilterSearchParamsParam {
  filters: IDirectDealFilter[];
}

interface ICreateDirectDealFilterSearchParamsReturn {
  brand?: string;
  minEngineOutputPs: number;
  maxEngineOutputPs: number;
  minPrice: number;
  maxPrice: number;
  sort: string;
  count: number;
  page: number;
  status: string;
  machineType: string;
  rowConfig: string;
  minOperationTime: number;
  maxOperationTime: number;
}

export const createDirectDealFilterSearchParams = ({
  filters,
}: ICreateDirectDealFilterSearchParamsParam): ICreateDirectDealFilterSearchParamsReturn => {
  const getFilterOptionValues = (filterKey: string) =>
    filters
      .find((filter) => filter.key === filterKey)
      ?.options.filter((option: IDirectDealFilterOption) => option.isSelected)
      .map((option: IDirectDealFilterOption) => option.value)
      .join(',');

  const sorterFilterOptionValues = getFilterOptionValues('sorter');
  const brandFilterOptionValues = getFilterOptionValues('filter_brand');
  const engineOutputPsFilterOptionValues = getFilterOptionValues('engineOutputInPs');
  const priceFilterOptionValues = getFilterOptionValues('price');
  const statusFilterOptionValues = getFilterOptionValues('status');
  const machineTypeFilterOptionValues = getFilterOptionValues('machineType');
  const rowConfigFilterOptionValues = getFilterOptionValues('rowConfig');
  const operationTimeFilterOptionValues = getFilterOptionValues('operationTime');

  const engineOutputPsMin = Number(engineOutputPsFilterOptionValues?.split(',')[0]);
  const engineOutputPsMax = Number(engineOutputPsFilterOptionValues?.split(',')[1]);

  const priceMin = Number(priceFilterOptionValues?.split(',')[0]);
  const priceMax = Number(priceFilterOptionValues?.split(',')[1]);

  const operationTimeMin = Number(operationTimeFilterOptionValues?.split(',')[0]);
  const operationTimeMax = Number(operationTimeFilterOptionValues?.split(',')[1]);

  return {
    brand: brandFilterOptionValues ?? undefined,
    minEngineOutputPs: engineOutputPsMin ?? 0,
    maxEngineOutputPs: engineOutputPsMax ?? 0,
    minPrice: priceSliderValueMapping[priceMin] ?? 0,
    maxPrice: priceSliderValueMapping[priceMax] ?? 0,
    sort: sorterFilterOptionValues ?? 'default_desc',
    count: 10,
    page: 1,
    status: statusFilterOptionValues ?? '',
    machineType: machineTypeFilterOptionValues ?? '',
    rowConfig: rowConfigFilterOptionValues ?? '',
    minOperationTime: operationTimeMin ?? 0,
    maxOperationTime: operationTimeMax ?? 0,
  };
};
